import { Button } from '@optools/components/ui/button';
import { DialogClose, DialogFooter } from '@optools/components/ui/dialog';
import { CloudAlert } from 'lucide-react';

export function BulkAssetUpdatesWarning() {
  return (
    <div>
      <div className="mb-6 flex flex-col items-center">
        <CloudAlert className="mb-2 size-8 text-yellow-500" />
        <h2>Bulk Update Partial Success</h2>
        <p className="mb-4 text-sm text-primary/80">The polling threshold has been reached.</p>

        <p className="text-sm text-primary/80">
          {' '}
          Although the update request was successful, some asset states may not be up to date.
          Please review the results and resubmit a request if needed.
        </p>
      </div>
      <DialogFooter>
        <DialogClose asChild>
          <Button>Close</Button>
        </DialogClose>
      </DialogFooter>
    </div>
  );
}
